import React from 'react';

const ShareIcon = ({ color = '#000', width = 18, height = 18 }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 49 48"
  >
    <path
      d="M28.3713 14.8938V11.4488C28.3713 9.52046 30.7113 8.54546 32.0763 9.91046L42.0213 19.8555C42.8663 20.7005 42.8663 22.0655 42.0213 22.9105L32.0763 32.8555C30.7113 34.2205 28.3713 33.2671 28.3713 31.3388V27.6771C18.2709 27.6771 10.9956 30.6906 5.66747 37.2442C5.39558 37.5787 4.84026 37.3271 4.94348 36.9086C7.45981 26.7076 14.054 16.9391 28.3713 14.8938Z"
      stroke={color}
      strokeWidth="2.5"
    />
  </svg>
);

export default ShareIcon;
